import { z } from "zod";

import { WidgetSchema } from "../../../widgets";

export const PluginWidgetSchema_2023_08_20 = WidgetSchema;
export type PluginWidgetType_2023_08_20 = z.infer<
  typeof PluginWidgetSchema_2023_08_20
>;
